import React from 'react';
import GenericCRUDPage from '../../components/GenericCRUDPage';
import JalaliDatePicker from '../../components/JalaliDatePicker';
import { FormField, Input, Select, Textarea, Badge } from '../../components/UI';
import { patientService } from '../../api/services';
import { toJalali } from '../../utils/jalali';

const PatientFormFields = ({ form: { register, watch, setValue } }) => (
  <div className="grid grid-cols-2 gap-4">
    <FormField label="Full Name" required>
      <Input {...register('name', { required: 'Required' })} placeholder="Patient name" />
    </FormField>
    <FormField label="Phone">
      <Input {...register('phone')} placeholder="+93 700 000 000" />
    </FormField>
    <FormField label="Date of Birth">
      <JalaliDatePicker value={watch('dateOfBirth')||''} onChange={v=>setValue('dateOfBirth',v)} placeholder="Date of birth" className="w-full"/>
    </FormField>
    <FormField label="Gender">
      <Select {...register('gender')}>
        <option value="">Select gender</option>
        <option value="male">Male</option>
        <option value="female">Female</option>
        <option value="other">Other</option>
      </Select>
    </FormField>
    <FormField label="Blood Type">
      <Select {...register('bloodType')}>
        <option value="">Select blood type</option>
        {['A+','A-','B+','B-','AB+','AB-','O+','O-'].map(bt => <option key={bt} value={bt}>{bt}</option>)}
      </Select>
    </FormField>
    <FormField label="Email">
      <Input type="email" {...register('email')} placeholder="email@example.com" />
    </FormField>
    <div className="col-span-2">
      <FormField label="Address">
        <Textarea {...register('address')} rows={2} placeholder="Address" />
      </FormField>
    </div>
    <div className="col-span-2">
      <FormField label="Known Allergies">
        <Input {...register('allergies')} placeholder="e.g. Penicillin, Aspirin (comma separated)" />
      </FormField>
    </div>
    <div className="col-span-2">
      <FormField label="Chronic Diseases">
        <Input {...register('chronicDiseases')} placeholder="e.g. Diabetes, Hypertension (comma separated)" />
      </FormField>
    </div>
    <div className="col-span-2">
      <FormField label="Notes">
        <Textarea {...register('notes')} rows={2} placeholder="Additional notes" />
      </FormField>
    </div>
  </div>
);

const columns = [
  { key: 'name', label: 'Name', sortable: true },
  { key: 'phone', label: 'Phone' },
  { key: 'gender', label: 'Gender', render: (v) => v ? <span className="capitalize">{v}</span> : '-' },
  { key: 'bloodType', label: 'Blood Type' },
  { key: 'allergies', label: 'Allergies', render: (v) => v?.join(', ') || '-' },
  { key: 'createdAt', label: 'Registered', render: (v) => toJalali(v) },
  { key: 'isActive', label: 'Status', render: (v) => <Badge color={v ? 'green' : 'gray'}>{v ? 'Active' : 'Inactive'}</Badge> },
];

export default function PatientsPage() {
  return (
    <GenericCRUDPage
      title="Patients"
      subtitle="Manage patient records"
      service={patientService}
      entityName="Patient"
      columns={columns}
      FormFields={PatientFormFields}
      modalSize="lg"
    />
  );
}
